/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Growth_Title_LeadInputs */

const en_about_growth_title_lead = /** @type {(inputs: About_Growth_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A facility built for`)
};

const es_about_growth_title_lead = /** @type {(inputs: About_Growth_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una instalación construida para`)
};

const de_about_growth_title_lead = /** @type {(inputs: About_Growth_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Anlage`)
};

const zh_about_growth_title_lead = /** @type {(inputs: About_Growth_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为整个社区打造的`)
};

const ar_about_growth_title_lead = /** @type {(inputs: About_Growth_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`منشأة بُنيت لـ`)
};

const fr_about_growth_title_lead = /** @type {(inputs: About_Growth_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une installation construite pour`)
};

const vi_about_growth_title_lead = /** @type {(inputs: About_Growth_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cơ sở xây dựng cho`)
};

const sw_about_growth_title_lead = /** @type {(inputs: About_Growth_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kituo kilichojengwa kwa ajili ya`)
};

const th_about_growth_title_lead = /** @type {(inputs: About_Growth_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สิ่งอำนวยความสะดวกที่สร้างขึ้นเพื่อ`)
};

const bs_about_growth_title_lead = /** @type {(inputs: About_Growth_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objekat građen za`)
};

const ja_about_growth_title_lead = /** @type {(inputs: About_Growth_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`地域全体のために造られた`)
};

const ko_about_growth_title_lead = /** @type {(inputs: About_Growth_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`지역 사회 전체를 위해`)
};

const pt_about_growth_title_lead = /** @type {(inputs: About_Growth_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um espaço feito para`)
};

const it_about_growth_title_lead = /** @type {(inputs: About_Growth_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una struttura costruita per`)
};

const sv_about_growth_title_lead = /** @type {(inputs: About_Growth_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En anläggning byggd för`)
};

const nl_about_growth_title_lead = /** @type {(inputs: About_Growth_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een faciliteit gebouwd voor`)
};

const da_about_growth_title_lead = /** @type {(inputs: About_Growth_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Et anlæg bygget til`)
};

const nb_about_growth_title_lead = /** @type {(inputs: About_Growth_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Et anlegg bygget til`)
};

const fi_about_growth_title_lead = /** @type {(inputs: About_Growth_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laitos, joka on rakennettu`)
};

const pl_about_growth_title_lead = /** @type {(inputs: About_Growth_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obiekt zbudowany dla`)
};

const ru_about_growth_title_lead = /** @type {(inputs: About_Growth_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Комплекс, построенный для`)
};

const tr_about_growth_title_lead = /** @type {(inputs: About_Growth_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bütün topluluk için`)
};

const hi_about_growth_title_lead = /** @type {(inputs: About_Growth_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूरे समुदाय के लिए बनी`)
};

const id_about_growth_title_lead = /** @type {(inputs: About_Growth_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sebuah fasilitas dibangun untuk`)
};

const ms_about_growth_title_lead = /** @type {(inputs: About_Growth_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kemudahan yang dibina untuk`)
};

const cs_about_growth_title_lead = /** @type {(inputs: About_Growth_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zařízení postavené pro`)
};

const el_about_growth_title_lead = /** @type {(inputs: About_Growth_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Μια εγκατάσταση που χτίστηκε για`)
};

const he_about_growth_title_lead = /** @type {(inputs: About_Growth_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מתקן שנבנה עבור`)
};

const af_about_growth_title_lead = /** @type {(inputs: About_Growth_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`'n Fasiliteit gebou vir`)
};

const hu_about_growth_title_lead = /** @type {(inputs: About_Growth_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Létesítmény`)
};

/**
* | output |
* | --- |
* | "A facility built for" |
*
* @param {About_Growth_Title_LeadInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_growth_title_lead = /** @type {((inputs?: About_Growth_Title_LeadInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Growth_Title_LeadInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_growth_title_lead(inputs)
	if (locale === "de") return de_about_growth_title_lead(inputs)
	if (locale === "zh") return zh_about_growth_title_lead(inputs)
	if (locale === "ar") return ar_about_growth_title_lead(inputs)
	if (locale === "fr") return fr_about_growth_title_lead(inputs)
	if (locale === "vi") return vi_about_growth_title_lead(inputs)
	if (locale === "sw") return sw_about_growth_title_lead(inputs)
	if (locale === "th") return th_about_growth_title_lead(inputs)
	if (locale === "bs") return bs_about_growth_title_lead(inputs)
	if (locale === "ja") return ja_about_growth_title_lead(inputs)
	if (locale === "ko") return ko_about_growth_title_lead(inputs)
	if (locale === "pt") return pt_about_growth_title_lead(inputs)
	if (locale === "it") return it_about_growth_title_lead(inputs)
	if (locale === "sv") return sv_about_growth_title_lead(inputs)
	if (locale === "nl") return nl_about_growth_title_lead(inputs)
	if (locale === "da") return da_about_growth_title_lead(inputs)
	if (locale === "nb") return nb_about_growth_title_lead(inputs)
	if (locale === "fi") return fi_about_growth_title_lead(inputs)
	if (locale === "pl") return pl_about_growth_title_lead(inputs)
	if (locale === "ru") return ru_about_growth_title_lead(inputs)
	if (locale === "tr") return tr_about_growth_title_lead(inputs)
	if (locale === "hi") return hi_about_growth_title_lead(inputs)
	if (locale === "id") return id_about_growth_title_lead(inputs)
	if (locale === "ms") return ms_about_growth_title_lead(inputs)
	if (locale === "cs") return cs_about_growth_title_lead(inputs)
	if (locale === "el") return el_about_growth_title_lead(inputs)
	if (locale === "he") return he_about_growth_title_lead(inputs)
	if (locale === "af") return af_about_growth_title_lead(inputs)
	if (locale === "hu") return hu_about_growth_title_lead(inputs)
	return en_about_growth_title_lead(inputs)
});